
const API_KEY = "b056ccef4d43fd7a371880801ae5b585"

const requests = {
    fetch_N_Trending: `/trending/all/week?api_key=${API_KEY}&language=en-US`,
    fetch_N_Orignals: `/discover/tv?api_key=${API_KEY}&with_networks=213`,
    fetch_N_TopRated: `/movie/top_rated?api_key=${API_KEY}&language=en-US`,
    fetch_N_Action: `/discover/movie?api_key=${API_KEY}&with_genres=28`,
    fetch_N_Comedy: `/discover/movie?api_key=${API_KEY}&with_genres=35`,
    fetch_N_Horror: `/discover/movie?api_key=${API_KEY}&with_genres=27`,
    fetch_N_Romance: `/discover/movie?api_key=${API_KEY}&with_genres=10749`,
    fetch_N_Documentaries: `/discover/movie?api_key=${API_KEY}&with_genres=99`,

}
const fetch_img_requests = {
    baseURL: "https://image.tmdb.org/t/p/original/"
}

const request_logs = {
    requests,
    fetch_img_requests
}

export default request_logs;